const locationEvent = {
  ADD_LOCATION: 'ADD_LOCATION',
  EDIT_LOCATION: 'EDIT_LOCATION',
  DEL_LOCATION: 'DEL_LOCATION',
  CHECK_IMPORT_LOCATION: 'CHECK_IMPORT_LOCATION',
  IMPORT_LOCATION: 'IMPORT_LOCATION'
};

export default locationEvent;